import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import queryString from 'query-string';
import ErrorBoundary from '@common/components/ErrorBoundary';
import PageTemplate from '@renter-hub/components/PageTemplate';
import HomePage from '@renter-hub/pages/HomePage';
import LandingPage from '@renter-hub/pages/LandingPage';
import paths from '@renter-hub/pathsManifest';
import { getGlobalLogger } from '@zg-rentals/logger-base';
import '../../../../styles/globals.css';
import { pathsManifest } from '@zg-rentals/particles-js-auth';

interface PagesAppProps {
  brand: string;
  loggedIn: boolean;
  hasStrongAuthentication: boolean;
  location: any;
  user: { [key: string]: any };
}

const logger = getGlobalLogger('renter/component');

class App extends React.Component<PagesAppProps> {
  constructor(props: PagesAppProps) {
    super(props);
  }

  componentDidMount() {
    logger?.info('app mounted');
  }

  shouldComponentUpdate = (nextProps: PagesAppProps) => {
    if (
      nextProps.brand !== this.props.brand ||
      nextProps.loggedIn !== this.props.loggedIn ||
      nextProps.hasStrongAuthentication !== this.props.hasStrongAuthentication
    ) {
      return true;
    }
    return false;
  };

  renderLoggedOutRoutes = () => {
    const searchString = this.props.location.search;
    const queryParams = queryString.parse(searchString);
    const fromWhere = queryParams.fromWhere;

    return (
      <Switch>
        {fromWhere === 'make-a-payment' && (
          <Route
            render={({ staticContext }) => {
              if (staticContext) {
                (staticContext as any).status = 302;
                (staticContext as any).skipAppendQuery = true;
              }

              return <Redirect to={pathsManifest.zillow.signInPage(this.props.location.pathname, searchString)} />;
            }}
          />
        )}
        <Route
          path={paths.baseUrl}
          exact
          render={(routeProps) => <LandingPage {...routeProps} brand={this.props.brand} authenticated={false} />}
        />
        <Route path="*" render={() => <Redirect to={{ pathname: paths.baseUrl, search: '' }} />} />
      </Switch>
    );
  };

  renderLoggedInRoutes = () => {
    const searchString = this.props.location.search;
    const queryParams = queryString.parse(searchString);
    const inviteToken = queryParams.invite;
    const fromWhere = queryParams.fromWhere;

    return <HomePage brand={this.props.brand} inviteToken={inviteToken} fromWhere={fromWhere} />;
  };

  render() {
    const { loggedIn, hasStrongAuthentication } = this.props;
    return (
      <PageTemplate>
        <div id="renter-hub-wrapper">
          <ErrorBoundary>
            {!loggedIn && !hasStrongAuthentication ? this.renderLoggedOutRoutes() : this.renderLoggedInRoutes()}
          </ErrorBoundary>
        </div>
      </PageTemplate>
    );
  }
}

export default App;
